import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

// Create axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '',
  timeout: 10000,
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const authStore = useAuthStore()
    
    // Handle 403 Forbidden (token expired/invalid)
    if (error.response?.status === 403) {
      // Check if token is expired locally
      if (authStore.isTokenExpired()) {
        authStore.handleTokenExpiration()
        return Promise.reject(error)
      }
      
      // Try to verify token with backend
      try {
        const isValid = await authStore.verifyToken()
        if (!isValid) {
          authStore.handleTokenExpiration()
        }
      } catch (verifyError) {
        authStore.handleTokenExpiration()
      }
    }
    
    return Promise.reject(error)
  }
)

export default api
